const muiCardContentTheme = (theme) => {
  theme.overrides.MuiCardContent = {
    root: {
      padding: '8px 25px !important',
    },
  };
};

export default muiCardContentTheme;
